import { render, staticRenderFns } from "./NegoceHisto.vue?vue&type=template&id=1f7b0173"
import script from "./NegoceHisto.vue?vue&type=script&lang=js"
export * from "./NegoceHisto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports